import { animate, state, style, transition, trigger } from '@angular/animations';

export const fadePasswordHelp = trigger('fadePasswordHelp', [
  state(
    '*',
    style({
      height: '56px',
      opacity: 1,
    }),
  ),
  state(
    'void',
    style({
      height: '0px',
      opacity: 0,
    }),
  ),
  transition('* <=> void', [animate('200ms ease-out')]),
]);

export const fadeConsents = trigger('fadeConsents', [
  state(
    '*',
    style({
      opacity: 1,
    }),
  ),
  state(
    'void',
    style({
      height: '0px',
      opacity: 0,
    }),
  ),
  transition('* <=> void', [animate('200ms ease-out')]),
]);
